import useAuthStore from "../stores/auth";
import axios from "axios";

const attachErrorMessage = (error: any) => {
  const data = error?.response?.data;
  error.message = data?.message || error.message;
  error.code = data?.code;
  error.status = error?.response?.status;
  return Promise.reject(error);
};

export const request = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

request.interceptors.request.use(async (config) => {
  const token = useAuthStore.getState().token;
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

request.interceptors.response.use((config) => config, attachErrorMessage);

export default request;
